import { render } from "./ConsentModal.vue?vue&type=template&id=3a545044&ts=true"
import script from "./ConsentModal.vue?vue&type=script&lang=ts"
export * from "./ConsentModal.vue?vue&type=script&lang=ts"

import "./ConsentModal.vue?vue&type=style&index=0&id=3a545044&lang=scss"

import exportComponent from "/srv/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__